import { z } from "zod"

import { type E164PhoneOptions, makeZE164Phone } from "./e164Phone"


type RpcbaseZodExtension = typeof z & {
  e164Phone?: (options?: E164PhoneOptions) => z.ZodString
}

type ExtendableZodPrototype = {
  unique?: (this: unknown, arg?: boolean) => unknown
  sparse?: (this: unknown, arg?: boolean) => unknown
}

declare module "zod" {
  interface ZodString {
    unique(arg?: boolean): this
    sparse(arg?: boolean): this
  }

  interface ZodNumber {
    unique(arg?: boolean): this
    sparse(arg?: boolean): this
  }

  interface ZodDate {
    unique(arg?: boolean): this
    sparse(arg?: boolean): this
  }

}

let zodPrototypesExtended = false

export function extendZod(zod: typeof z) {
  const zodWithExtension = zod as RpcbaseZodExtension
  if (Object.isExtensible(zodWithExtension) && typeof zodWithExtension.e164Phone !== "function") {
    zodWithExtension.e164Phone = (options?: E164PhoneOptions) => makeZE164Phone(zod, options)
  }

  if (zodPrototypesExtended) return
  zodPrototypesExtended = true

  const supported = [zod.ZodString, zod.ZodNumber, zod.ZodDate] as const
  for (const type of supported) {
    const proto = type?.prototype as ExtendableZodPrototype | undefined
    if (!proto) continue

    proto.unique = function unique(this: unknown, _flag = true) {
      return this
    }

    proto.sparse = function sparse(this: unknown, _flag = true) {
      return this
    }
  }
}
